import { createContext, useContext } from 'react'
import { usePresupuesto } from '../hooks/usePresupuesto'

const PresupuestoContext = createContext(null)

export function PresupuestoProvider({ children }) {
  return <PresupuestoContext.Provider value={usePresupuesto()}>{children}</PresupuestoContext.Provider>
}

export function usePresupuestoContext() {
  return useContext(PresupuestoContext)
}
